var _brandModelCode, _brandModelColorCode;
const getBrandModelAttributes = (serverVariant)=>({
        brandModelCode: (_brandModelCode = serverVariant.variantTypeDetails.brandModelCode) !== null && _brandModelCode !== void 0 ? _brandModelCode : undefined,
        brandModelColorCode: (_brandModelColorCode = serverVariant.variantTypeDetails.brandModelColorCode) !== null && _brandModelColorCode !== void 0 ? _brandModelColorCode : undefined
    })
;

export { getBrandModelAttributes };
//# sourceMappingURL=get-brand-model-attributes.js.map
